module.exports = __webpack_public_path__ + "static/media/cookie.c7debc79.svg";